module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-8.4c671ae0.svg";